import React from "react";
import { Outlet } from "react-router-dom";

const UserTypeRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default UserTypeRoot;
